/**
 * Homepage FAQ accordion. The open/close animation is pure CSS
 * (grid-template-rows 0fr <-> 1fr on .homepage-faq__a-wrap); this only
 * flips aria-expanded on the question button, which the CSS keys off.
 * Items toggle independently (multiple can be open at once).
 */
export default function initFaqAccordion() {
  const buttons = document.querySelectorAll('.homepage-faq__q');

  buttons.forEach((btn) => {
    if (btn.dataset.faqBound === '1') return;
    btn.dataset.faqBound = '1';

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });
}
